function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M2 9l7-7m0 0l7 7M9 2v17.5",
  fill: "currentColor",
  stroke: "#039BE8",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgArrowTop = function SvgArrowTop(props) {
  return React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml,%3Csvg width='18' height='21' viewBox='0 0 18 21' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath d='M2 9L9 2M9 2L16 9M9 2V19.5' fill='currentColor' stroke='%23039BE8' stroke-width='3' stroke-linecap='round' stroke-linejoin='round' /%3E %3C/svg%3E";
export { SvgArrowTop as ReactComponent };